import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useLayoutEffect } from 'react';
import { isDefined, isFalsyString, bound, isTruthyString } from '@togglecorp/fujs';
import InputContainer from '../InputContainer/index.js';
import RawInput from '../RawInput/index.js';
import { genericMemo } from '../../utils/index.js';

function isValidNumericString(val) {
  return /^[+-]?\d+(\.\d+)?$/.test(val);
}

function isValidDecimalTrailingZeroString(val) {
  return /^[+-]?\d+\.\d*0$/.test(val);
}

function NumberInput(props) {
  const {
    actions,
    actionsContainerClassName,
    className,
    disabled,
    error,
    errorContainerClassName,
    hint,
    hintContainerClassName,
    icons,
    iconsContainerClassName,
    inputSectionClassName,
    inputElementRef,
    inputClassName,
    label,
    labelContainerClassName,
    readOnly,
    uiMode,
    onChange,
    name,
    value,
    variant,
    inputDescription,
    ...rawInputProps
  } = props;
  const containerRef = React.useRef(null);
  const inputSectionRef = React.useRef(null);
  const [tempValue, setTempValue] = useState();
  useLayoutEffect(() => {
    // NOTE: we don't clear tempValue if it is equal to input value
    // eg. tempValue: 1.00000, value: 1
    setTempValue(val => isDefined(val) && isValidNumericString(val) && +val === value ? val : undefined);
  }, [value]);
  const handleChange = React.useCallback((v, n, event) => {
    if (!onChange) {
      return;
    }

    if (isFalsyString(v)) {
      setTempValue(undefined);
      onChange(undefined, n, event);
      return;
    }

    if (!isValidNumericString(v)) {
      setTempValue(v);
      return;
    } // NOTE: we set tempValue if it is valid but is a transient state
    // eg. 1.0000 is valid but transient


    setTempValue(isValidDecimalTrailingZeroString(v) ? v : undefined);
    const numericValue = bound(+v, -Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER);
    onChange(numericValue, n, event);
  }, [onChange]);
  const finalValue = tempValue ?? (isDefined(value) ? String(value) : undefined);
  return /*#__PURE__*/React.createElement(InputContainer, {
    containerRef: containerRef,
    inputSectionRef: inputSectionRef,
    actions: actions,
    actionsContainerClassName: actionsContainerClassName,
    className: className,
    disabled: disabled,
    error: error,
    errorContainerClassName: errorContainerClassName,
    hint: hint,
    hintContainerClassName: hintContainerClassName,
    icons: icons,
    iconsContainerClassName: iconsContainerClassName,
    inputSectionClassName: inputSectionClassName,
    label: label,
    labelContainerClassName: labelContainerClassName,
    readOnly: readOnly,
    uiMode: uiMode,
    invalid: isTruthyString(tempValue),
    variant: variant,
    input: /*#__PURE__*/React.createElement(RawInput, _extends({}, rawInputProps, {
      elementRef: inputElementRef,
      className: inputClassName,
      readOnly: readOnly,
      uiMode: uiMode,
      disabled: disabled,
      onChange: handleChange,
      name: name,
      value: finalValue
    })),
    inputDescription: inputDescription
  });
}

var NumberInput$1 = genericMemo(NumberInput);

export { NumberInput$1 as default };
//# sourceMappingURL=index.js.map
